import React from 'react';
import { ShieldCheckIcon, AlertTriangleIcon } from 'lucide-react';
export function CoursePrerequisites() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1134">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1135">
        <div className="mb-12" data-id="element-1136">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1137">
            Course Prerequisites
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1138">
            <div className="space-y-4" data-id="element-1139">
              <div className="flex items-start gap-3" data-id="element-1140">
                <ShieldCheckIcon size={20} className="flex-shrink-0 mt-0.5" style={{
                color: '#1e3d2f'
              }} data-id="element-1141" />
                <p className="text-base text-gray-800 leading-relaxed" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1142">
                  Student must possess either a currently valid MI CPL or a MI
                  CPL that is not expired for more than 12 months.
                </p>
              </div>
              <div className="flex items-start gap-3 p-4 rounded-lg" style={{
              backgroundColor: '#fffbeb',
              border: '1px solid #c8a84b'
            }} data-id="element-1143">
                <AlertTriangleIcon size={20} className="flex-shrink-0 mt-0.5" style={{
                color: '#c8a84b'
              }} data-id="element-1144" />
                <p className="text-base text-gray-800 leading-relaxed" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1145">
                  Students with a CPL expired more than 12 months are required
                  by law to retake the entire class.{' '}
                  <strong data-id="element-1146">No discount is offered</strong> when CPL is expired
                  for more than 12 months.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}